<template>
  <a class="gp" :href="`/blogs/${article.handle}`" :aria-label="`Read more about ${article.title}`">
    <ImageField
      class="gp__image"
      :obj="{ url: article.image, alt: article.title, width: 832, height: 630 }"
      width-param="width"
      sizes="1000px"
    />
    <div class="gp__info">
      <div class="gp__info--inner">
        <h2 class="gp__title">{{ article.title }}</h2>
        <p class="gp__desc" v-html="article.description"></p>
      </div>
      <div class="gp__tag-time">
        <span v-if="tag" class="gp__tag" aria-label="Article category: {{ tag }}">{{ tag }}</span>
        <span v-if="timeToRead" class="gp__time" aria-label="Estimated reading time: {{ timeToRead }} minutes"
          >{{ timeToRead }} min Read</span
        >
      </div>
    </div>
  </a>
</template>

<script setup>
  import { computed, toRefs } from 'vue';
  import ImageField from '../../global/image.vue';

  const props = defineProps({
    article: {
      type: Object,
      required: true,
    },
  });

  const { article } = toRefs(props);

  const tag = computed(() => {
    const catTag = article.value.tags.filter((tag) => tag.includes('category:'));
    if (catTag.length) {
      return catTag[0].split(':')[1];
    }
  });

  const timeToRead = computed(() => {
    const timeTag = article.value.tags.filter((tag) => tag.includes('time:'));
    if (timeTag.length) {
      return timeTag[0].split(':')[1];
    }
  });
</script>
